// extracted by mini-css-extract-plugin
export default {"icon":"index_icon__NqTpe","avatar":"index_avatar__TLxQa","submitButton":"index_submitButton__MN8NL","disabled":"index_disabled__5G45r"};